import React from 'react';
import "./GridDataLegend.scss"
import { useTranslation } from "react-i18next";

function GridDataLegend() {
    const { t } = useTranslation();
    const segmentEx = "ABC YYZ";
    const redEyeEx = "(25:40)";
    const normalEx = "(13:40)";
    return (
        <div className="container grid-container">
            <div className='gridDataLegend'>
                <div className="legend">
                    <p className="legend-label">{t(`pairingPackage.gridDataLegend.legend`)}</p>
                    <div className="verticalBar"></div>
                </div>
                <p className="legend-deadhead"><span className="dead-head">{segmentEx}</span> = {t(`pairingPackage.gridDataLegend.deadhead`)}</p>
                <p className="legend-redeye"><span className="red-eye">{redEyeEx}</span> = {t(`pairingPackage.gridDataLegend.longLayover`)}</p>
                <p className="legend-normal"><span className="normal">{normalEx}</span> = {t(`pairingPackage.gridDataLegend.shortLayover`)}</p>
            </div>
        </div>
    );
}

export default GridDataLegend;
